import { Alert } from "@mui/material";
import Cookies from "js-cookie";
import { useEffect, useState } from "react";
import { Trans, useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../../axios";
import "../../i18n";
import SessionExpireUi from "./SessonExpireUi";

export let orgClassesData = {classes:[]};

const HeadingOfLicne = () => {
    const { t, i18n } = useTranslation();
    const [open, setOpen] = useState(true);
    const plan = parseInt(Cookies.get("plan"));
    const organization_id = Cookies.get("organization");
    const Individual = localStorage.getItem('LearnersList');
    const [OrgData, setOrgData] = useState('');
    const [OrgData2, setOrgData2] = useState('');
    const [Loading, setLoading] = useState(false);
    const [ReLogin, setReLogin] = useState(false);
    // Get Organization info
    useEffect(() => {
        setLoading(true);
        const getOrgDetail = async () => {
            try {
                const respons = await axiosInstance.get(`${process.env.REACT_APP_ENDPOINT}/organization/${organization_id}/classes/`);
                setOrgData(respons.data.ending_date);
                setOrgData2(respons.data);
                orgClassesData = respons.data;                
            } catch (error) {
                console.error(error);
                error?.response?.status === 500 && setReLogin(true);
            } finally {
                setLoading(false);
            }
        };
        getOrgDetail()
    }, []);
    // count remaining days of plan for expiring
    const parseDate = (endingDate) => {
        // Parse the date string (format: DD/MM/YYYY)
        const [day, month, year] = endingDate.split('/').map(Number);
        return new Date(year, month - 1, day);
    };
    const [RemainigDays, setRemainigDays] = useState(0);
    useEffect(() => {
        const getRemainingDays = (endingDate) => {
            // const endDate = parseDate(OrgData); // Parse the ending date
            const endDate = parseDate(OrgData); // Parse the ending date
            const currentDate = new Date(); // Get the current date

            // Calculate the difference in time (in milliseconds)
            const timeDifference = endDate - currentDate;

            // Convert milliseconds to days (1 day = 24 * 60 * 60 * 1000)
            const remainingDays = Math.ceil(timeDifference / (1000 * 60 * 60 * 24));
            // Ensure that if the date is in the past, return 0
            setRemainigDays(remainingDays > 0 ? remainingDays : 0);
        };
        getRemainingDays();
    }, [OrgData])
    //   Repay handle
    const navigate = useNavigate();
    const handleRepay = () => {
        navigate(`/upgradeplan`, { state: { license_type: OrgData2.license_type, bill_type: OrgData2.bill_type, organization_id: OrgData2.organization_id, ending_by: OrgData2.ending_date } })
    }

    return (
        <div>
            <SessionExpireUi ReLogin={ReLogin} setReLogin={setReLogin} />
            {Individual === 'show' && plan !== 0 && RemainigDays > 0 && RemainigDays < 10 && open && <Alert severity='warning' onClose={() => setOpen(false)}>
                <Trans i18nKey={"Settings.RemainingDays"} values={{ days: RemainigDays }} components={{ bold: <strong /> }} /> <span onClick={handleRepay} to='/Dashboard/settings' className="font-bold cursor-pointer">{t('Settings.UpgradeNow')}</span></Alert>}
        </div>
    )
};
export default HeadingOfLicne;